<template>
  <v-app id="example-2" standalone>
    <v-navigation-drawer
      v-model="drawer"
      v-if="showLayout"
      :mini-variant.sync="mini"
      class="blue-grey darken-4"
      width="260"
      fixed
      dark
      app
      mobile-break-point="1000"
      id="main-drawer"
    >
      <v-toolbar flat class="k-orange-linear" height="60">
        <v-list class="pa-0">
          <v-list-tile avatar>
            <v-list-tile-action>
              <v-btn icon @click.native.stop="mini = !mini">
                <v-icon>menu</v-icon>
              </v-btn>
            </v-list-tile-action>
            <v-list-tile-content>
              <a href="/">
                <img
                  class="img-responsive-logo"
                  :src="require('@/assets/img/colektia.png')"
                  alt="Colektia"
                />
              </a>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-toolbar>
      <v-divider></v-divider>
      <v-list>
        <template v-for="item in items"
          v-if="checkPermissions(item.permissions)">
          <v-list-tile
            @click="$router.push(item.link)"
            :key="item.title"
            v-if="!item.hasOwnProperty('childrens') && item.title !== 'Inteligencia de Cobranza'"
          >
            <v-list-tile-action class="text-menu">
              <v-icon size="22">{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title class="text-menu">{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <template v-else>
            <v-list-group
              :key="`${item.title}-${item.childrens.length}`"
              v-if="item.title !== 'Inteligencia de Cobranza' || (item.title === 'Inteligencia de Cobranza' && item.childrens.length > 0)"
              :prepend-icon="item.icon">
              <v-list-tile-content slot="activator">
                <v-list-tile>
                  <v-list-tile-title class="text-menu">{{ item.title }}</v-list-tile-title>
                </v-list-tile>
              </v-list-tile-content>
              <template v-for="children in item.childrens">
                <v-list-tile
                  :key="children.title"
                  v-if="checkPermissions(children.permissions) && (!children.companyId || parseInt($auth.user().company_id, 10) === children.companyId)"
                  @click="$router.push(children.link)"
                >
                  <v-list-tile-content class="pl-5">
                    <v-list-tile-title class="text-menu">{{ children.title }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>
            </v-list-group>
          </template>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar
      v-if="showLayout"
      color="white"
      height="60"
      fixed
      app>
      <div class="d-flex w-100 align-center">
        <div>
          <v-toolbar-title v-if="mini">
            <img
              class="img-responsive-logo"
              :src="require('@/assets/img/colektia_red.png')"
              alt="Colektia"
            />
            {{ appVersion }}
          </v-toolbar-title>
        </div>
        <div class="d-flex align-center navbar-right justify-end">
          <div>
            <v-menu
              v-if="$store.state.dialer.callCenterStatus > 0 && $store.state.dialer.keepCalling"
              small
              offset-y>
              <v-btn color="red" class="mr-3" slot="activator">
                <v-icon color="white" class="f1em mr-2">fas fa-power-off</v-icon>
                <span class="white--text">Desconectar</span>
              </v-btn>
              <v-list>
                <v-list-tile
                  v-for="(disconnectReason, i) in $store.state.dialer.disconnectReasons"
                  :key="`disconnectReason-${i}`"
                  @click="stopCalling(disconnectReason)">
                  <v-list-tile-title>
                    {{ disconnectReason }}
                  </v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </div>
          <div class="mr-2">
            <img class="img-responsive-logo" :src="logo" alt="Colektia">
          </div>
          <div>
            <v-menu offset-y>
              <v-btn slot="activator" icon>
                <v-badge class="notification-badge" color="primary" :overlap="true" :value="totalNotification > 0">
                  <span slot="badge">{{ totalNotification }}</span>
                  <v-icon class="k-orange-linear-text">fas fa-bell</v-icon>
                </v-badge>
              </v-btn>
              <v-list two-line>
                <template v-for="(channel, index) in chatNotifications">
                  <v-list-tile v-if="channel.total !== 0"
                    :key="`chat-notification-channel-${index}`"
                    :to="{ path: '/chat_center' }">
                    <v-list-tile-avatar>
                      <v-icon class="k-orange-linear-text" v-if="channel.id === 7">fab fa-whatsapp</v-icon>
                      <v-icon class="k-orange-linear-text" v-if="channel.id === 1">fas fa-envelope</v-icon>
                      <v-icon class="k-orange-linear-text" v-if="channel.id === 2">fas fa-comment</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>{{ channel.name }}</v-list-tile-title>
                      <v-list-tile-sub-title>{{ channel.total }} Mensaje(s) nuevos</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider v-if="index !== 0 && index !== chatNotifications.length - 1 && channel.total !== 0" :key="`chat-notification-channel-divider-${index}`" ></v-divider>
                </template>
              </v-list>
            </v-menu>
            <v-menu offset-y>
              <v-btn icon dark slot="activator">
                <v-avatar class="k-orange-linear" size="35">
                  <span class="white--text headline">{{ $auth.user().first_name.substring(0, 1) }}</span>
                </v-avatar>
              </v-btn>
              <v-list>
                <v-subheader>{{ $auth.user().first_name }} {{ $auth.user().last_name }}</v-subheader>
                <v-divider></v-divider>
                <v-list-tile v-if="showChangeCompany" @click="show = true">
                  <v-list-tile-title>Cambiar de empresa</v-list-tile-title>
                </v-list-tile>
                <v-list-tile v-for="item in options" :key="item.title" @click="item.link">
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </div>
          <template v-if="$store.state.dialerV2.status > 0">
            <dialer-v2 v-if="$store.state.dialerV2.status === 3"></dialer-v2>
            <div v-if="!($store.state.dialerV2.status === 3 && !$store.state.dialerV2.keepCalling)">
              <v-menu
                :disabled="disconnectionInProgress || $store.state.dialerV2.reconnecting || !$store.state.dialerV2.keepCalling"
                small
                offset-y>
                <v-btn slot="activator" color="red" class="call-center-disconnect" :disabled="disconnectionInProgress || $store.state.dialerV2.reconnecting || !$store.state.dialerV2.keepCalling">
                  <v-icon v-if="disconnectionInProgress || !$store.state.dialerV2.keepCalling" color="white">fas fa-spinner fa-spin</v-icon>
                  <v-icon v-else-if="!disconnectionInProgress" color="white">fas fa-power-off</v-icon>
                </v-btn>
                <v-list>
                  <v-list-tile
                    v-for="(disconnectReason, i) in $store.state.dialerV2.disconnectReasons"
                    :key="`disconnectReasonV2-${i}`"
                    @click="requestDisconnection(disconnectReason)">
                    <v-list-tile-title>
                      {{ disconnectReason.name }}
                    </v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </div>
          </template>
        </div>
      </div>
    </v-toolbar>
    <v-content fill-height :class="{ open: !mini && closeNav && showLayout, closed: mini && closeNav }">
      <transition name="slide-fade" mode="out-in">
        <router-view></router-view>
      </transition>
      <download-load></download-load>
      <v-dialog v-model="dialog" persistent width="50%">
        <v-card>
          <v-card-text class="pt-4">
            <v-layout row>
              <v-flex xs3>
                <v-icon x-large class="error--text darken-1">info</v-icon>
              </v-flex>
              <v-flex xs9 class="error--text darken-1">{{textDialog}}</v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat="flat" @click.native="dialog = false">Continuar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogChangePassword" persistent max-width="600px">
        <v-card>
          <v-toolbar color="k-orange-linear" class="white--text">
            <v-toolbar-title>Cambia tú contraseña</v-toolbar-title>
          </v-toolbar>
          <v-card-text class="pt-4 px-5">
            <v-form>
              <v-layout row>
                <v-flex xs12>
                  <v-text-field
                    color="black"
                    label="Contraseña actual"
                    v-model="user.password"
                    type="password"
                    :error-messages="errors.collect('password')"
                    v-validate="'required|min:10|field-capital-letter|field-lowercase-letter|field-alphabetic-characters|field-two-numbers|field-special-chars'"
                    data-vv-name="password"
                    data-vv-as="contraseña actual"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12>
                  <v-text-field
                    color="black"
                    label="Contraseña nueva"
                    v-model="user.new_password"
                    type="password"
                    :error-messages="errors.collect('new_password')"
                    v-validate="'required|min:10|field-capital-letter|field-lowercase-letter|field-alphabetic-characters|field-two-numbers|field-special-chars'"
                    data-vv-name="new_password"
                    data-vv-as="contraseña nueva"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12>
                  <v-text-field
                    color="black"
                    type="password"
                    label="Confirmar contraseña"
                    v-model="user.confirm_password"
                    :error-messages="errors.collect('confirm_password')"
                    v-validate="'required|min:10|field-capital-letter|field-lowercase-letter|field-alphabetic-characters|field-two-numbers|field-special-chars'"
                    data-vv-name="confirm_password"
                    data-vv-as="confirmación de contraseña"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click.native="dialogChangePassword = false">Cancelar</v-btn>
            <v-btn class="k-orange-linear-text" flat @click="changePassword">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogDownloadReport" persistent width="50%">
        <v-card>
          <v-card-text class="pt-4 pb-4">
            <v-layout row wrap class="px-3">
              <v-flex xs12 class="text-xs-center mb-3">
                <v-icon class="f3-5em k-orange-linear-text">fas fa-download</v-icon>
              </v-flex>
              <v-flex
                xs12
                class="text-xs-center f1-1em my-2"
              >Se ha generado su reporte "{{titleReport}}" de manera exitosa!</v-flex>
              <v-flex xs12 class="text-xs-center">
                <v-btn
                  class="k-orange-linear-text k-orange-linear-underline elevation-0"
                  round
                  @click.native="downloadFile(fileName)"
                >DESCARGAR</v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogInfo" persistent width="50%" transition="dialog-transition">
        <v-card>
          <v-card-text class="pt-4 pb-4">
            <v-layout row wrap class="px-3">
              <v-flex xs12 class="text-xs-center mb-3">
                <v-icon slot="activator" class="f3-5em k-orange-linear-text">{{infoIcon}}</v-icon>
              </v-flex>
              <v-flex xs12 class="text-xs-center my-2">{{textDialog}}</v-flex>
              <v-flex xs12 class="text-xs-center">
                <v-btn
                  class="k-orange-linear-text k-orange-linear-underline elevation-0"
                  round
                  @click.native="dialogInfo = false"
                >CONTINUAR</v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-content>
    <wait-download-modal></wait-download-modal>
    <download-modal></download-modal>
    <download-error-modal></download-error-modal>
    <not-connection></not-connection>
    <v-container class="call-status position-fixed">
      <template v-for="call in $store.state.dialer.callsToSave">
        <call-status
          v-if="
            (
              call.type_id !== 7
              && call.type_id !== 9
            ) || (
              call.customer_id
              || (
                call.fiscal_id
                || call.first_name
                || call.last_name
              ) || call.call_id !== currentCall.call_id
            )
          "
        :key="`calls-to-save-${call.call_id || call.id}`"
        :notification="call"/>
      </template>
    </v-container>
    <template v-if="snackbars.length">
      <v-snackbar
        v-for="(snackbar, index) in snackbars"
        :key="`snackbar-item-${index}`"
        :top="true"
        :right="true"
        class="chat-info-snackbar"
        v-model="snackbar.active">
        <v-layout row wrap>
          <v-flex xs3>
            <v-icon class="k-orange-linear-text" v-if="snackbar.channel_id === 7">fab fa-whatsapp</v-icon>
            <v-icon class="k-orange-linear-text" v-if="snackbar.channel_id === 1">fas fa-envelope</v-icon>
            <v-icon class="k-orange-linear-text" v-if="snackbar.channel_id === 2">fas fa-comment</v-icon>
          </v-flex>
          <v-flex xs9 class="text-truncate">
            <span class="">
              {{ snackbar.text }}
            </span>
          </v-flex>
        </v-layout>
        <v-btn flat color="pink" @click.native="snackbar.active = false">Cerrar</v-btn>
      </v-snackbar>
    </template>
    <audio id="callCenterAudio">
      <p>Your browser doesn't support HTML5 audio.</p>
    </audio>
    <change-company-modal
      :show="show"
      @change-company="changeCompany"
      @error="showError"
      @close="show = false">
    </change-company-modal>
  </v-app>
</template>

<script>
const roles = [
  'call center DC',
  'chat center DC',
];
const companies = [/*26521363*/];
import Vue from 'vue';
import _ from 'lodash';
// import moment from 'moment-timezone';
import { mapGetters } from 'vuex';
import waitDownloadModal from '@/components/global/StartDownloadModal';
import DownloadLoad from '@/components/global/DownloadLoad';
import DownloadModal from '@/components/global/DownloadModal';
import DownloadErrorModal from '@/components/global/DownloadErrorModal';
import FormatLastMessage from '@/mixins/formatLastMessage';
import removeImgTags from '@/mixins/removeImgTags';
import removeHtmlTags from '@/mixins/removeHtmlTags';
import CallStatus from '@/components/CallCenter/StatusV2';
import DialerV2 from '@/components/CallCenter/DialerV2';
// import CallStatusIncoming from '@/components/CallCenter/StatusIncoming';
import NotConnection from '@/components/global/NotConnection';
import ChangeCompanyModal from '@/components/global/ChangeCompanyModal/ChangeCompanyModal';
import { clearWorkflowFiltersCache } from '@/mixins/workflowFilters';
import { startBackupUploader } from '@/services/callRecording/uploader';
import EventBus from './event-bus';

export default {
  components: {
    DownloadLoad,
    DownloadModal,
    waitDownloadModal,
    DownloadErrorModal,
    NotConnection,
    CallStatus,
    DialerV2,
    ChangeCompanyModal,
    // CallStatusIncoming,
  },
  $_veeValidate: {
    validator: 'new',
  },
  inject: ['$validator'],
  mixins: [
    FormatLastMessage,
    removeImgTags,
    removeHtmlTags,
  ],
  created() {
    EventBus.$on('startListenEvent', () => {
      if (!this.listening) {
        this.startListening();
      }
    });
    EventBus.$on('stopListenEvent', () => {
      if (!this.listening) {
        this.stopListening();
      }
    });
    EventBus.$on('hideMenu', () => {
      this.mini = true;
    });
    EventBus.$on('modal', ($text) => {
      this.dialog = true;
      this.textDialog = $text;
    });
    EventBus.$on('infoModal', ($text, $icon) => {
      this.dialogInfo = true;
      this.textDialog = $text;
      this.infoIcon = $icon;
    });
    EventBus.$on('drawer', ($drawer) => {
      this.drawer = $drawer;
    });
    EventBus.$on('error', ($errors) => {
      Object.keys($errors).forEach((key) => {
        this.errors.add({
          field: key,
          msg: $errors[key][0],
        });
      });
    });
  },
  mounted() {
    this.startListeningChatCenter();
    // Sube en segundo plano las grabaciones de backup pendientes en IndexedDB
    // (incluidas las de sesiones anteriores o interrumpidas por un crash).
    startBackupUploader();
  },
  data() {
    return {
      show: false,
      req: {},
      drawer: null,
      dialog: false,
      snackbars: [],
      chatCenterSnackbar: false,
      dialogDownloadReport: false,
      disconnectionInProgress: false,
      titleReport: '',
      dialogInfo: false,
      mini: false,
      textDialog: '',
      infoIcon: '',
      dashboard_items: [
        {
          icon: 'fa-chart-line',
          title: 'Inteligencia de Cobranza',
          permissions: [
            'see_quicksight_dashboards',
          ],
          childrens: [],
        },
      ],
      user: {
        password: '',
        new_password: '',
        confirm_password: '',
      },
      dialogChangePassword: false,
      options: [
        {
          title: 'Cambiar contraseña',
          link: this.dialogeChangePassword,
        },
        {
          title: 'Salir',
          link: this.logout,
        },
      ],
      redoPing: 0,
      chatNotifications: [
        {
          id: 7,
          name: 'Whatsapp',
          total: 0,
        },
        {
          id: 2,
          name: 'Sms',
          total: 0,
        },
        {
          id: 1,
          name: 'Email',
          total: 0,
        },
      ],
      workFlowMenu: {},
    };
  },
  computed: {
    ...mapGetters({
      userVuex: 'user/user'
    }),
    items() {

      const strategyChildren = [
        {
          title: 'Flujo de bot',
          link: '/bot_v4',
          permissions: [
            'create_templates',
            'see_templates',
            'edit_templates',
            'delete_templates',
          ],
        },
        {
          title: 'Flujo de ivr',
          link: '/ivr_v2',
          permissions: [
            'create_templates',
            'see_templates',
            'edit_templates',
            'delete_templates',
          ],
        },
        {
              title: 'Plantillas de whatsapp',
              link: '/whatsapp_templates',
              permissions: [
                'see_whatsapp_templates',
                'create_whatsapp_templates',
                'edit_whatsapp_templates',
                'delete_whatsapp_templates',
              ],
            },
        // {
        //   title: 'Flujo de canales',
        //   link: '/workflow_channels',
        //   permissions: [
        //     'create_workflow_channels',
        //     'see_workflow_channels',
        //     'edit_workflow_channels',
        //     'delete_workflow_channels',
        //   ],
        // },
        ...[this.workFlowMenu || {}],
      ];
      return [
        // {
        //   icon: 'fas fa-tachometer-alt',
        //   title: 'Panel',
        //   link: '/panel',
        //   permissions: [
        //     'see_daily_managements',
        //   ],
        // },
        {
          icon: 'fas fa-comments',
          title: 'Chat center',
          link: '/chat_center',
          permissions: [
            'see_chat_center',
          ],
        },
        ...!(companies.includes(this.AuthUser.company_id) && roles.includes(this.AuthUser.role)) && [{
          icon: 'fas fa-user',
          title: 'Clientes',
          link: '/customers',
          permissions: [
            'see_customers',
          ],
        }],
        {
          icon: 'fas fa-clipboard-list',
          title: 'Gestión',
          link: '/notification_schedules',
          permissions: [
            'see_daily_managements',
          ],
        },
        {
          icon: 'fa fa-bullseye',
          customIcon: true,
          title: 'Estrategia',
          permissions: [
            'create_templates',
            'see_templates',
            'edit_templates',
            'delete_templates',
            'create_workflow_channels',
            'see_workflow_channels',
            'edit_workflow_channels',
            'delete_workflow_channels',
            'create_workflow_notifications',
            'see_workflow_notifications',
            'edit_workflow_notifications',
            'delete_workflow_notifications',
            'edit_whatsapp_workflow',
            'see_whatsapp_templates',
            'create_whatsapp_templates',
            'edit_whatsapp_templates',
            'delete_whatsapp_templates',
          ],
          childrens: strategyChildren,
        },
        {
          icon: 'fas fa-phone fa-flip-horizontal',
          title: 'Call center',
          permissions: [
            'see_call_center',
            'see_call_center_operators',
            'connect_campaign_call_center',
            'numx_see_call_center_algorithm',
          ],
          childrens: [
            {
              title: 'Campañas',
              link: '/calls_lists',
              permissions: [
                'see_call_center',
              ],
            },
            {
              title: 'Operadores',
              link: '/call_center/users',
              permissions: [
                'see_call_center_operators',
              ],
            },
            {
              title: 'Conectarse',
              link: '/call_center/connect',
              permissions: [
                'connect_campaign_call_center',
              ],
            },
            {
              title: 'Encuestas de satisfacción',
              link: '/surveys',
              permissions: [
                'create_survey',
                'edit_survey',
                'delete_survey',
              ],
            },
            {
              title: 'Algoritmo de selección',
              link: '/numx/call_center/algorithm',
              permissions: [
                'numx_see_call_center_algorithm',
              ],
              companyId: 26521363,
            },
          ],
        },
        {
          icon: 'fas fa-flag',
          title: 'Campañas',
          permissions: [
            'see_campaigns',
            'create_templates',
            'see_templates',
            'edit_templates',
            'delete_templates',
          ],
          childrens: [
            {
              title: 'Gestión',
              link: '/campaigns',
              permissions: [
                'see_campaigns',
                'create_campaigns',
              ],
            },
            {
              title: 'Plantillas',
              link: '/campaigns/templates',
              permissions: [
                'create_templates',
                'see_templates',
                'edit_templates',
                'delete_templates',
              ],
            },
          ],
        },
        // {
        //   icon: 'description',
        //   title: 'Reportes',
        //   permissions: [
        //     'see_reports',
        //     'see_daily_managements',
        //   ],
        //   childrens: [
        //     {
        //       title: 'Clientes',
        //       link: '/reports/customers',
        //       permissions: [
        //         'see_reports',
        //       ],
        //     },
        //     {
        //       title: 'Gestión',
        //       link: '/reports/notification_schedule',
        //       permissions: [
        //         'see_daily_managements',
        //       ],
        //     },
        //     {
        //       title: 'Gestiones',
        //       link: '/reports/notification_schedules',
        //       permissions: [
        //         'see_daily_managements',
        //       ],
        //     },
        //     {
        //       title: 'Call center',
        //       link: '/reports/call_center',
        //       permissions: [
        //         'see_reports',
        //       ],
        //     },
        //     {
        //       title: 'Productos',
        //       link: '/reports/product',
        //       permissions: [
        //         'see_reports',
        //       ],
        //     },
        //     {
        //       title: 'Segmentación',
        //       link: '/reports/segmentation',
        //       permissions: [
        //         'see_reports',
        //       ],
        //     },
        //     {
        //       title: 'Consumo',
        //       link: '/reports/invoice',
        //       permissions: [
        //         'see_reports',
        //       ],
        //     },
        //   ],
        // },
        ...this.dashboard_items,
        // {
        //   icon: 'fas fa-database',
        //   title: 'Datos',
        //   permissions: [
        //     'create_load_logs',
        //     'see_load_logs',
        //     'see_data_quality',
        //     'see_purses',
        //   ],
        //   childrens: [
        //     {
        //       title: 'Carga',
        //       link: '/load_logs',
        //       permissions: [
        //         'create_load_logs',
        //         'see_load_logs',
        //       ],
        //     },
        //     {
        //       title: 'Descarga',
        //       link: '/report_downloads',
        //       permissions: [
        //         'create_report_downloads',
        //         'see_report_downloads',
        //       ],
        //     },
        //     {
        //       title: 'Calidad de datos',
        //       link: '/data_quality/management',
        //       permissions: [
        //         'see_data_quality',
        //       ],
        //     },
        //     {
        //       title: 'Datos invalidos',
        //       link: '/invalid_data',
        //       permissions: [
        //         'see_invalid_data',
        //       ],
        //     },
        //     {
        //       title: 'Cartera',
        //       link: '/daily_collections',
        //       permissions: [
        //         'see_purses',
        //       ],
        //     },
        //   ],
        // },
        {
          icon: 'settings',
          title: 'Configuración',
          permissions: [
            'create_users',
            'chat_config',
            'see_users',
            'edit_users',
            'delete_users',
            'see_customers',
            'create_company_emails',
            'see_company_emails',
            'edit_company_emails',
            'delete_company_emails',
            'see_answer_templates',
            'create_answer_templates',
            'edit_answer_templates',
            'delete_answer_templates',
            'create_workflow_channels',
            'see_workflow_channels',
            'edit_workflow_channels',
            'delete_workflow_channels',
            'create_workflow_notifications',
            'see_workflow_notifications',
            'edit_workflow_notifications',
            'edit_whatsapp_workflow',
            'delete_workflow_notifications',
            'create_chat_categories',
            'see_chat_categories',
            'edit_chat_categories',
            'delete_chat_categories',
            'create_domains',
            'see_domains',
            'edit_domains',
            'delete_domains',
            'edit_company_status',
            'see_company_status',
          ],
          childrens: [
            {
              title: 'Usuarios',
              link: '/users',
              permissions: [
                'create_users',
                'see_users',
                'edit_users',
                'delete_users',
              ],
            },
            // {
            //   title: 'Validación de nombres',
            //   link: '/validate/customers/name',
            //   permissions: [
            //     'see_customers',
            //   ],
            // },
            /* {
              title: 'Respuestas',
              link: '/config/answer_templates',
              permissions: [
                'create_answer_templates',
                'see_answer_templates',
                'edit_answer_templates',
                'delete_answer_templates',
              ],
            }, */
            // {
            //   title: 'Email',
            //   link: '/company_emails',
            //   permissions: [
            //     'create_company_emails',
            //     'see_company_emails',
            //     'edit_company_emails',
            //     'delete_company_emails',
            //   ],
            // },
            /* {
              title: 'Chat center',
              link: '/config/chat_center',
              permissions: [
                'chat_config',
              ],
            },
            {
              title: 'Categorias de chat',
              link: '/chat_categories',
              permissions: [
                'create_chat_categories',
                'see_chat_categories',
                'edit_chat_categories',
                'delete_chat_categories',
              ],
            }, */
            // {
            //   title: 'Dominios',
            //   link: '/domains',
            //   permissions: [
            //     'create_domains',
            //     'see_domains',
            //     'edit_domains',
            //     'delete_domains',
            //   ],
            // },
            // {
            //   title: 'Homologación de estados',
            //   link: '/homologation',
            //   permissions: [
            //     'see_company_status',
            //     'edit_company_status',
            //   ],
            // },
            // {
            //   title: 'Estados de contención',
            //   link: '/config/containment_states',
            //   permissions: [
            //     'see_content_status_config',
            //     'edit_content_status_config',
            //   ],
            // },
          ],
        },
      ];
    },
    appVersion() {
      return process.env.APP_VERSION;
    },
    closeNav() {
      let result = false;
      if (this.$auth.check()) {
        result = true;
      }
      if (['FirstLogin', 'NexusEmail', 'verificationCode'].includes(this.$route.name) ) {
        result = false;
      }
      return result;
    },
    AuthUser() {
      return this.$auth.user() || {};
    },
    canSeeDashboards() {
      if (Object.keys(this.AuthUser).length === 0) {
        return false;
      }
      const total = this.AuthUser.permissions.filter(item => item === 'see_quicksight_dashboards');
      return total.length > 0;
    },
    logo() {
      let src = '';
      if (this.$auth.user().company_id !== 17322821519) {
        src = `https://files.colektia.com/company_logos/${this.$auth.user().company_id}.png`;
      } else {
        src = `https://files.colektia.com/company_logos/${this.$auth.user().company_id}.svg`;
      }
      return src;
    },
    channel() {
      return Object.keys(this.AuthUser).length ? `company.${this.AuthUser.company.id}.chatCenter` : '';
    },
    isAdmin() {
      return this.AuthUser.role === 'admin';
    },
    chatCenterConected() {
      return this.AuthUser.chat_center_online || false;
    },
    totalNotification() {
      let total = 0;
      if (this.chatNotifications.length) {
        this.chatNotifications.forEach((channel) => {
          total += channel.total;
        });
      }
      return total;
    },
    currentCall() {
      return this.$store.state.dialer.notification || this.$store.state.dialerV2.currentCall || {};
    },
    showLayout() {
      const verified = !!this.$store.getters['user/user'].verified;
      return (
        this.$auth.check()
        && this.$auth.user().status === 'activo'
        && this.$route.name !== 'VpnDisconnected'
        && (
          this.$auth.user().nexus_email
          || parseInt(this.$auth.user().company_id, 10) === 17322821519
          || parseInt(this.$auth.user().company_id, 10) === 8230622
        )
        && (
          verified
          || (this.$route.name !== 'verificationCode' && this.$route.name !== 'Login')
          || parseInt(this.$auth.user().company_id, 10) === 17322821519
          || parseInt(this.$auth.user().company_id, 10) === 8230622
        )
      );
    },
    showChangeCompany() {
      const oldInfra = this.$store.state.dialer.callCenterStatus > 0;
      const newInfra = this.$store.state.dialerV2.status > 0;
      const hasCalls = this.$store.state.dialer.callsToSave.length;
      return this.$auth.user().total_companies > 1 && !oldInfra && !newInfra && !hasCalls;
    },
  },
  methods: {
    stopCalling(disconnectReason) {
      this.$store.commit('dialer/SET_DISCONNECT_REASON', disconnectReason);
      this.$store.commit('dialer/SET_KEEP_CALLING', false);
      if (this.$store.state.dialer.callCenterStatus === 3) {
        this.axios.post(`${process.env.LAMBDA_API_URL}/api/call_center/stop_calling`, {
          user_id: this.$auth.user().id,
        })
          .then(() => {
          })
          .catch(() => {
            EventBus.$emit('modal', 'Ocurrio un error al desconectar.');
          });
      }
    },
    checkPermissions(authorisationsNeeded) {
      return _.intersection(authorisationsNeeded, this.$auth.user().permissions).length > 0 || this.$auth.user().role === 'admin';
    },
    logout() {
      if (this.$store.state.dialer.callCenterStatus === 0) {
        this.$store.commit('CLEAN_DOWNLOAD_QUEUE');
        this.$store.dispatch('LEAVE_DOWNLOAD_EVENT');
        localStorage.clear();
        this.$auth.logout({
          redirect: '/login',
        });
        // Parando grabaciones de refinanciamiento.
        this.$store.dispatch('dialer/setCallRecording', {});
      } else {
        EventBus.$emit('modal', 'No puede salir mientras esta en una llamada');
      }
    },
    downloadFile() {
      this.axios({
        url: `/reports/download?file=${this.fileName}`,
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {
        if (!window.navigator.msSaveOrOpenBlob) {
          // BLOB NAVIGATOR
          const url = window.URL.createObjectURL(response.data);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', this.fileName);
          document.body.appendChild(link);
          link.click();
        } else {
          // BLOB FOR EXPLORER 11
          window.navigator.msSaveOrOpenBlob(response.data, this.fileName);
        }
        this.dialogDownloadReport = false;
      });
    },
    /* eslint-disable */
    stopListening() {
      window.Echo.leave('whatever_event');
    },
    startListening() {
      this.listening = true;
      window.Echo.channel('whatever_event') // eslint-disable-line
      .listen('.whatever_message', (event) => {
        EventBus.$emit('infoModal', event.text, event.icon);
        this.stopListening();
      });
      window.Echo.private(`company.${this.$auth.user().company.id}.${this.$auth.user().id}.download_report`) // eslint-disable-line
      .listen('.reportGenerated', (event) => {
        this.fileName = event.filename;
        this.titleReport = event.filename.replace('.xlsx', '');
        this.dialogDownloadReport = true;
      });
    },
    /* eslint-enable */
    dialogeChangePassword() {
      Object.keys(this.user).forEach((key) => {
        if (Array.isArray(this.user[key])) {
          this.user[key] = [];
        } else {
          this.user[key] = '';
        }
      });
      this.$nextTick(() => {
        this.$validator.reset();
        this.errors.clear();
      });
      this.dialogChangePassword = true;
    },
    changePassword() {
      this.axios.post('user/password/reset', {
        old_password: this.user.password,
        new_password: this.user.new_password,
        confirm_password: this.user.confirm_password,
      }).then(async ({ data }) => {
        if (data.code === 403) {
          EventBus.$emit('modal', data.message);
        } else {
          this.dialogChangePassword = false;
          Object.keys(this.user).forEach((key) => {
            if (Array.isArray(this.user[key])) {
              this.user[key] = [];
            } else {
              this.user[key] = '';
            }
          });
          this.$nextTick(() => {
            this.$validator.reset();
            this.errors.clear();
          });
        }
      });
    },
    passFilters(chatCenter) {
      let flag = true;
      if (Object.keys(this.AuthUser).length < 1) {
        flag = false;
      }
      if (chatCenter.user_id !== this.AuthUser.id) {
        flag = false;
      }
      if (chatCenter.chat_center_status_id === 7) {
        flag = false;
      }
      if (chatCenter.path === '/chat_center') {
        flag = false;
      }
      return flag;
    },
    startListeningChatCenter() {
      if (this.channel) {
        window.Echo.private(this.channel)
          .listen('.ChatCenterUpdated', ({ chatCenter }) => {
            if (this.passFilters(chatCenter)) {
              if (this.chatCenterConected) {
                const snackbar = {
                  active: true,
                  channel_id: chatCenter.channel_id,
                  text: this.formatLastMessage(chatCenter.chat_center_messages),
                };
                this.snackbars.push(snackbar);
              }
              const channel = this.chatNotifications
                .find(item => item.id === chatCenter.channel_id) || {};
              channel.total += 1;
            }
            localStorage.setItem('notificationList', JSON.stringify(this.chatNotifications));
          });
      }
    },
    stopListeningChatCenter() {
      window.Echo.leave(this.channel);
    },
    clearNotificationValues() {
      this.chatNotifications.forEach((item) => {
        item.total = 0; // eslint-disable-line
      });
      this.clearNotificationStorage();
    },
    clearNotificationStorage() {
      localStorage.removeItem('notificationList');
    },
    requestDisconnection(disconnectReason) {
      this.disconnectionInProgress = true;
      this.$store.dispatch('dialerV2/requestDisconnection', disconnectReason)
        .finally(() => {
          this.disconnectionInProgress = false;
        });
    },
    showError($event) {
      EventBus.$emit('modal', $event);
    },
    changeCompany() {
      clearWorkflowFiltersCache();
      this.$auth.fetch().then(() => {
        this.show = false;
        // this.$router.push({ name: 'home' });
        window.location.href = '/inicio';
      });
    },
  },
  watch: {
    '$route.path'(value) { // eslint-disable-line
      if (value === '/chat_center') {
        this.clearNotificationValues();
      }
    },
    mini(newVal) {
      EventBus.$emit('navbarToggled', newVal);
    },
    AuthUser: {
      deep: true,
      immediate: true,
      handler (value) {
        if (value.id) {
          if (Object.keys(value).length > 0 && value.permissions.includes('see_quicksight_dashboards')) {
            this.axios.get('dashboards').then(({ data }) => {
              const items = this.dashboard_items.find(item => item.title === 'Inteligencia de Cobranza');
              items.childrens = [
                ...data.dashboards.map(dashboard => ({
                  link: `/dashboards/${dashboard.id}`,
                  title: dashboard.name,
                  permissions: [
                    'see_quicksight_dashboards',
                  ],
                })),
              ];
            });
          }
          const old_workflow = {
            title: 'Flujo de cobranza',
            link: '/flows_v2',
            permissions: [
              'create_workflow_notifications',
              'see_workflow_notifications',
              'edit_workflow_notifications',
              'delete_workflow_notifications',
              'edit_whatsapp_workflow',
            ],
          };
          this.axios.get('check_release', {
            params: {
              name: 'new_workflow',
            },
          })
            .then(({ data }) => {
              if (data.is_active) {
                this.workFlowMenu = {
                  title: 'Flujo de cobranza',
                  link: '/flows_v3',
                  permissions: [
                    'create_workflow_notifications',
                    'see_workflow_notifications',
                    'edit_workflow_notifications',
                    'delete_workflow_notifications',
                    'edit_whatsapp_workflow',
                  ],
                };
              } else {
                this.workFlowMenu = old_workflow;
              }
            })
            .catch(err => {
              this.workFlowMenu = old_workflow;
            });
          // Call center
          const callsToSave = localStorage.getItem('calls_to_save');
          const callType = localStorage.getItem('call_type');
          const maxCommitmentDays = localStorage.getItem('max_commitment_days');
          if (callsToSave) {
            this.$store.state.dialer.callsToSave = JSON.parse(callsToSave);
          }
          if (
            this.$auth.user().call_center_status > 0
            && !this.$store.state.dialer.callCenterStatus
            && callType === 'zoom'
          ) {
            this.$store.dispatch('dialer/startCallCenterZoom', {
              type: 'reconnect',
              call_list_id: this.$auth.user().call_list_id,
              conference_id: this.$auth.user().conference_id,
              call_type: 'zoom',
              max_commitment_days: maxCommitmentDays,
            });
          } else if (
            this.$auth.user().call_center_status > 0
            && !this.$store.state.dialer.callCenterStatus
            && callType === 'predictive'
          ) {
            this.$store.dispatch('dialer/startCallCenterPredictive', {
              type: 'reconnect',
              call_list_id: this.$auth.user().call_list_id,
              call_type: 'predictive',
              max_commitment_days: maxCommitmentDays,
            });
          } else if (
            this.$auth.user().call_center_status > 0
            && !this.$store.state.dialer.callCenterStatus
            && callType === 'softphone'
          ) {
            this.$store.dispatch('dialer/startCallCenterSoftphone', {
              type: 'reconnect',
              call_list_id: this.$auth.user().call_list_id,
              call_type: 'softphone',
              max_commitment_days: maxCommitmentDays,
            });
          }
          this.$store.commit('dialer/SET_IS_RECORDING', String(localStorage.getItem('is_recording')) === 'true');
          this.$store.commit('dialer/SET_CURRENT_RECORDING', JSON.parse(localStorage.getItem('current_recording') || '{}'));
          if (value.status === 'activo') {
            this.startListeningChatCenter();
            this.$store.dispatch('GET_CONFIG').catch();
            this.$store.dispatch('GET_NO_PAYMENT_REASONS');
            this.$store.dispatch('GET_STATES');
            this.$store.dispatch('GET_AGENTS');
            this.$store.dispatch('GET_GENDERS');
            this.$store.dispatch('GET_ACCOUNT');
            this.$store.dispatch('GET_CHANNELS');
            this.$store.dispatch('GET_STATUSES');
            this.$store.dispatch('GET_TRANCHES');
            this.$store.dispatch('GET_ANGENCIES');
            this.$store.dispatch('GET_DUE_DATES');
            this.$store.dispatch('GET_PORTFOLIOS');
            this.$store.dispatch('GET_DIMENTIONS');
            this.$store.dispatch('GET_AGE_GROUPS');
            this.$store.dispatch('GET_COMPANY_LOAD');
            this.$store.dispatch('GET_CUSTOMER_STATUSES');
            this.$store.dispatch('GET_INTENTIONS');
            this.$store.dispatch('GET_SUB_STATUSES');
            this.$store.dispatch('GET_REFINANCING_STATUSES');
            this.$store.dispatch('GET_INBOUND_STATUSES');
            this.$store.dispatch('GET_AGREEMENT_STATUSES');
          }
        } else {
          this.stopListeningChatCenter();
        }
      },
    },
    chatCenterConected(value) {
      if (!value) {
        this.stopListeningChatCenter();
      }
    },
  },
};
</script>

<style scoped>
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s;
}
.slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(30px);
  opacity: 0;
}
.slide-fade-enter {
  transform: translateX(-30px);
  opacity: 0;
}
.img-responsive-logo {
  width: auto;
  height: auto;
  max-height: 30px;
  margin-top: 0px;
}
.text-menu {
  font-weight: normal !important;
  color: #b0bec5;
}
.logo-mini {
  padding-left: 80px;
}
.closed {
  padding: 55px 0px 0px 80px !important;
}
.open {
  padding: 55px 0px 0px 260px !important;
}
.notification-badge >>> .badge__badge {
  width: 18px;
  height: 18px;
  font-size: 10px;
}
.navbar-right {
  margin-left: auto;
}
.navbar-right > div {
  flex: 0 0 auto !important;
  margin-right: 10px;
}
.call-center-disconnect {
  width: 45px;
  min-width: 45px;
  min-height: 45px;
  border-radius: 8px;
}
.chat-info-snackbar >>> .snack__content {
  background-color: #F2F2F2 !important;
  color: #333;
}
.text-truncate {
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.call-status {
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  position: fixed;
  z-index: 50;
}
.custom-icon {
  width: 22px;
  height: 22px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue